'use client';

import { c as _c } from "react/compiler-runtime";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import type React from 'react';
import { DRAWER_WIDTH, DRAWER_WIDTH_CLOSED } from 'src/constants/styles';
import { styled } from '@mui/material/styles';
import { shouldForwardProp } from 'src/components/Particles/Particles';
interface AppBarProps extends Omit<MuiAppBarProps, 'open'> {
  open?: boolean;
  children: React.ReactNode;
}
type StyledAppBarProps = AppBarProps & MuiAppBarProps;
const StyledAppBar = styled(MuiAppBar, {
  ...shouldForwardProp(['open'])
})<StyledAppBarProps>(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  zIndex: theme.zIndex.drawer + 1,
  padding: `${theme.sizes.spacing['07']} ${theme.sizes.spacing['10']}`,
  gap: theme.sizes.spacing['08'],
  backgroundColor: theme.colors.surface.tertiary,
  borderBottom: `${theme.sizes.borderWidth[1]} solid ${theme.colors.border.secondary}`,
  shadow: 'none',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  '& .MuiIconButton-root': {
    padding: `${theme.sizes.spacing.none}`,
    margin: `${theme.sizes.spacing.none}`,
    color: `${theme.colors.icon.primary}`,
    disableRipple: true,
    height: 'auto',
    '&:hover, &.MuiButtonBase-root:hover': {
      color: `${theme.colors.surface['brand-active']}`,
      backgroundColor: `${theme.colors.surface.tertiary}`
    }
  },
  variants: [{
    props: ({
      open
    }) => open,
    style: {
      marginLeft: DRAWER_WIDTH,
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    }
  }, {
    props: ({
      open
    }) => !open,
    style: {
      marginLeft: DRAWER_WIDTH_CLOSED,
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  }]
}));
const AppBar: React.FC<AppBarProps> = t0 => {
  const $ = _c(8);
  let children;
  let open;
  let props;
  if ($[0] !== t0) {
    ({
      open,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = open;
    $[3] = props;
  } else {
    children = $[1];
    open = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== open || $[6] !== props) {
    t1 = <StyledAppBar position="fixed" open={open} elevation={0} {...props}>{children}</StyledAppBar>;
    $[4] = children;
    $[5] = open;
    $[6] = props;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
export default AppBar;
export type { AppBarProps };